import {createContext, Dispatch, FC, SetStateAction, useContext, useState} from 'react'
import {ISmsRouteConfig} from './_model'
import {WithChildren} from '../../../_metronic/helpers'

type ConfigRoutesType = {
  searchTerm: string
  setSearchTerm: Dispatch<SetStateAction<string>>
  updateRoute: ISmsRouteConfig | null
  setUpdateRoute: Dispatch<SetStateAction<ISmsRouteConfig | null>>
  deleteRoute: ISmsRouteConfig | null
  setDeleteRoute: Dispatch<SetStateAction<ISmsRouteConfig | null>>
  resetSelected: () => void
}

export const ConfigRoutesContext = createContext<ConfigRoutesType | null>(null)

export const ConfigRoutesProvider: FC<WithChildren> = ({children}) => {
  const [searchTerm, setSearchTerm] = useState('')
  const [updateRoute, setUpdateRoute] = useState<ISmsRouteConfig | null>(null)
  const [deleteRoute, setDeleteRoute] = useState<ISmsRouteConfig | null>(null)

  const resetSelected = () => {
    setUpdateRoute(null)
    setDeleteRoute(null)
  }

  return (
    <ConfigRoutesContext.Provider
      value={{
        searchTerm,
        updateRoute,
        deleteRoute,
        setDeleteRoute,
        setUpdateRoute,
        setSearchTerm,
        resetSelected,
      }}
    >
      {children}
    </ConfigRoutesContext.Provider>
  )
}

export const useRouteConfig = () => {
  const context = useContext(ConfigRoutesContext)

  if (!context) {
    throw Error('Must be wrappet within Config Provider')
  }

  return context
}
